
const Nav=()=>{
    return(
        <nav>
            <h2>Emojee</h2>
            <a href="https://github.com/UmangNagar">GitHub</a>
        </nav>
    )
}
export default Nav;